/* eslint-disable @typescript-eslint/no-explicit-any */
import { usePage } from "@inertiajs/react";
import { PremiumServiceInterface } from "@/ts/interfaces/Enrol/ProgramServicesInterface";

const useEnrolPageProps = () => {
    const props = usePage().props as unknown as {
        hubspotEventEnrol: string;
        premiumServiceList: PremiumServiceInterface[];
    };

    return props;
};

export default useEnrolPageProps;
